import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Menu, Transition } from '@headlessui/react'
import { faCaretRight, faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllSkillsForDropDown } from '../../redux/actions/skills';
import { Mixpanel } from '../../config/Mixpanel';
import { classNames } from '../../utils/classNames'
import Constants from '../../common/constants';
import { fetchIsUserFromBetaProduct } from '../../redux/actions/personaliseCourse';

const CoursesDropdownV2 = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [allCourses, setAllCourses] = useState([]);
    const [skills, setSkills] = useState(null);
    const [selectedCourse, setActiveCourse] = useState(null);
    const [selectedSkill, setActiveSkill] = useState(null);
    const all_courses = useSelector(store => store?.courses?.allCourses)
    const location = useLocation()
    const regex = /^.*\/.*\/.*\/.*\/\d+$/
    const email = useSelector(store => store?.profileDetails?.email)
    const [unlockedCourses, setUnlockedCourses] = useState([]);
    const user_role = useSelector((store) => store?.userSubscription?.user_role);
    const [isBeta, setIsBeta] = useState(false);
    const user_id = useSelector((store)=> store?.profileDetails?.id);

    useEffect(() => {
        // dispatch(
        //   getPersonaliseUnlockedCourses(
        //     email,
        //     (succesObj) => {
        //       setUnlockedCourses(succesObj);
        //     },
        //     (errorObj) => {}
        //   )
        // );
        if(user_id){
        dispatch(
          fetchIsUserFromBetaProduct((res) => {
            console.log("monday", res);
            if (res?.data?.is_ninjacurate_user || res?.data?.ninjacurate_is_paid) {
              setIsBeta(true);
            }
          })
        );
    }
      }, [user_id]);
      

    useEffect(() => {

        setAllCourses(all_courses);
        setActiveCourse(all_courses?.[0])

        const course_slug = all_courses?.[0]?.course_slug
        if (!regex.test(location.pathname) && (!skills || !skills?.[course_slug] )) {
            dispatch(getAllSkillsForDropDown(course_slug, (res) => {
                setSkills({
                    ...skills,
                    [course_slug]: res
                });
                setActiveSkill(res[0])
            }))
        };
    }, [])

    const handleSkillClick = (e) => {
        e.stopPropagation();
        Mixpanel.track(Constants.Mixpanel.DROPDOWN_SKILL_CLICK, {
            distinct_id: email
        })
    }

    const handleMSkillClick = (e) => {
        e.stopPropagation();
        // Mixpanel.track(Constants.Mixpanel.DROPDOWN_SKILL_CLICK, {
        //     distinct_id: email
        // })

        // to be changed for mskills
    }

    const handleCourseClick = (e) => {
        e.stopPropagation();
        Mixpanel.track(Constants.Mixpanel.DROPDOWN_COURSE_CLICK, {
            distinct_id: email
        })
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button className="flex items-center gap-[7px] py-[11px] px-4 text-[13px] font-semibold text-[#0E1B2E] hover:bg-black/5 transition-colors border-r border-[#DDE4ED] whitespace-nowrap outline-none focus:outline-none">
                    <span>All Categories</span>
                    <svg className="w-[15px] h-[15px] text-[#4A5A70]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="origin-top-left absolute left-0 top-full mt-2.5 w-[940px] flex flex-row rounded-[16px] bg-white border border-[#DDE4ED] shadow-[0_12px_32px_0_rgba(0,0,0,0.15)] focus:outline-none overflow-hidden z-50">
                    {/* Left Column: Categories */}
                    <div className="w-[360px] h-[543px] shrink-0 border-r border-[#DDE4ED] p-4 flex flex-col bg-white">
                        <div className="px-4 py-2 text-[12px] font-bold tracking-[1px] text-[#78899F] uppercase font-sans">
                            CATEGORIES
                        </div>
                        <div className="flex-1 overflow-y-auto flex flex-col gap-1 pr-1">
                            {allCourses?.map((course, idx) => {
                                const isSelected = selectedCourse?.course_slug === course?.course_slug;
                                return (
                                    <Menu.Item key={course.course_slug + idx}>
                                        {({ active }) => (
                                            <div
                                                onMouseEnter={() => {
                                                    if (skills?.[course?.course_slug]?.length === 0 || !skills || !skills?.[course?.course_slug]) {
                                                        dispatch(getAllSkillsForDropDown(course?.course_slug, (res) => {
                                                            setSkills(prev => ({
                                                                ...prev,
                                                                [course.course_slug]: res
                                                            }));
                                                            setActiveSkill(res[0]);
                                                        }));
                                                    } else {
                                                        setActiveSkill(skills?.[course.course_slug]?.find(el => el.course_slug === course.course_slug) || skills?.[course.course_slug]?.[0]);
                                                    }
                                                    setActiveCourse(course);
                                                }}
                                                onClick={(e) => {
                                                    handleCourseClick(e);
                                                    navigate(`/${course.course_slug}`, { replace: true });
                                                }}
                                                className={classNames(
                                                    isSelected ? 'bg-[#EDF1F7] text-[#0E1B2E] font-semibold' : 'text-[#4A5A70] hover:bg-[#EDF1F7] hover:text-[#0E1B2E] font-medium',
                                                    'flex items-center justify-between px-4 py-3 rounded-[12px] text-[15px] cursor-pointer transition-colors'
                                                )}
                                            >
                                                <div className="flex items-center gap-3 min-w-0 pr-2">
                                                    {course?.course_icon?.url ? (
                                                        <img src={course.course_icon.url} alt="Course Icon" className="w-5 h-5 object-contain shrink-0" />
                                                    ) : (
                                                        <svg className={`w-5 h-5 shrink-0 ${isSelected ? 'text-[#06769E]' : 'text-[#4A5A70]'}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <polyline points="16 18 22 12 16 6"></polyline>
                                                            <polyline points="8 6 2 12 8 18"></polyline>
                                                        </svg>
                                                    )}
                                                    <span className="truncate">
                                                        {course["course-name"]?.replace("Course", "")?.trim()}
                                                    </span>
                                                </div>
                                                {isSelected && (
                                                    <svg className="w-4 h-4 text-[#78899F] shrink-0" viewBox="0 0 14 14" fill="currentColor">
                                                        <path d="M5.25 11.8125q-0.16406 0-0.30078-0.13672-0.13672-0.13672-0.13672-0.30078 0-0.16406 0.10938-0.32813l4.10156-4.04687-4.10156-4.04688q-0.10938-0.16406-0.08204-0.32812 0.02734-0.16406 0.13672-0.27344 0.10938-0.10938 0.27344-0.13672 0.16406-0.02734 0.32813 0.08203l4.375 4.375q0.10938 0.16406 0.10937 0.32813 0 0.16406-0.10937 0.32812l-4.375 4.375q-0.16406 0.10938-0.32813 0.10938z" />
                                                    </svg>
                                                )}
                                            </div>
                                        )}
                                    </Menu.Item>
                                );
                            })}
                        </div>
                    </div>

                    {/* Right Column: Skills */}
                    <div className="w-[580px] h-[543px] p-8 flex flex-col gap-6 bg-white">
                        <div className="flex items-center justify-between px-3">
                            <h3 className="text-[22px] font-bold text-[#0E1B2E]">
                                {selectedCourse?.["course-name"]?.replace("Course", "")?.trim() || "All"} Skills
                            </h3>
                            {selectedCourse?.course_slug && (
                                <Link
                                    to={`/${selectedCourse.course_slug}`}
                                    onClick={handleCourseClick}
                                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#06769E] hover:underline"
                                >
                                    <span>View all skills</span>
                                    <svg className="w-4 h-4 text-[#06769E]" viewBox="0 0 14 14" fill="currentColor">
                                        <path d="M12.14063 7.32813l-3.9375 3.9375q-0.16406 0.10938-0.32813 0.10937-0.16406 0-0.30078-0.13672-0.13672-0.13672-0.13672-0.30078 0-0.16406 0.10938-0.32812l3.22656-3.17188-8.58594 0q-0.16406 0-0.30078-0.13672-0.13672-0.13672-0.13672-0.30078 0-0.16406 0.13672-0.30078 0.13672-0.13672 0.30078-0.13672l8.58594 0-3.22657-3.17188q-0.10938-0.16406-0.08203-0.32812 0.02734-0.16406 0.13672-0.27344 0.10938-0.10938 0.27344-0.13672 0.16406-0.02734 0.32812 0.08203l3.9375 3.9375q0.10938 0.16406 0.10938 0.32813 0 0.16406-0.10938 0.32812z" />
                                    </svg>
                                </Link>
                            )}
                        </div>

                        {/* Skills Grid */}
                        <div className="flex-1 overflow-y-auto pr-1">
                            {skills?.[selectedCourse?.course_slug]?.length > 0 ? (
                                <div className="grid grid-cols-2 gap-x-4 gap-y-2 px-1">
                                    {skills[selectedCourse.course_slug].map((skill_item, idx) => (
                                        <Menu.Item key={skill_item?.skill_slug + idx}>
                                            {({ active }) => (
                                                <Link
                                                    to={`/${selectedCourse.course_slug}/${skill_item?.["skill_slug"]}`}
                                                    onClick={handleSkillClick}
                                                    onMouseEnter={() => setActiveSkill(skill_item)}
                                                    className={classNames(
                                                        active || selectedSkill?.skill_slug === skill_item?.skill_slug
                                                            ? 'bg-[#EDF1F7] text-[#0E1B2E] font-semibold'
                                                            : 'text-[#0E1B2E] font-medium hover:bg-[#EDF1F7]',
                                                        'flex items-center justify-between p-3 rounded-[8px] transition-colors group cursor-pointer'
                                                    )}
                                                >
                                                    <span className="text-[15px] truncate pr-2 group-hover:text-[#06769E] transition-colors">
                                                        {skill_item?.["skill-name"]}
                                                    </span>
                                                    <svg className="w-4 h-4 text-[#78899F] shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 14 14" fill="currentColor">
                                                        <path d="M5.25 11.8125q-0.16406 0-0.30078-0.13672-0.13672-0.13672-0.13672-0.30078 0-0.16406 0.10938-0.32813l4.10156-4.04687-4.10156-4.04688q-0.10938-0.16406-0.08204-0.32812 0.02734-0.16406 0.13672-0.27344 0.10938-0.10938 0.27344-0.13672 0.16406-0.02734 0.32813 0.08203l4.375 4.375q0.10938 0.16406 0.10937 0.32813 0 0.16406-0.10937 0.32812l-4.375 4.375q-0.16406 0.10938-0.32813 0.10938z" />
                                                    </svg>
                                                </Link>
                                            )}
                                        </Menu.Item>
                                    ))}
                                </div>
                            ) : skills?.[selectedCourse?.course_slug] ? (
                                <div className="text-center py-16 text-[14px] text-[#78899F]">
                                    No skills available for this category
                                </div>
                            ) : (
                                <div className="grid grid-cols-2 gap-x-4 gap-y-2 px-1">
                                    {[...Array(8)].map((_, i) => (
                                        <div key={i} className="h-11 rounded-[8px] bg-[#EDF1F7] animate-pulse" />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </Menu.Items>
            </Transition>
        </Menu >
    )
}

export default CoursesDropdownV2